"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getStackBarChartOptions = exports.getChartOptions = exports.makeColor = exports.formatForBar = exports.filterZeroImpactIgnorance = exports.getGroupedData = void 0;
var MAX_CHART_HEIGHT = 100000;
var sortingOptions = {
    Alpha: "alpha",
    AlphaDesc: "alphaDESC",
    Value: "value"
};
function getChartHeight(numOfBars) {
    var base = 60;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 300);
}
function truncateText(text, maxLength) {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
}
function returnSortedObject(originalObject, yAxisSort, yAxisKey) {
    var sortedObject = __assign({}, originalObject);
    if (yAxisSort == sortingOptions.Alpha) {
        sortedObject = Object.keys(originalObject)
            .sort()
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    else if (yAxisSort == sortingOptions.AlphaDesc) {
        sortedObject = Object.keys(originalObject)
            .sort(function (a, b) { return b.localeCompare(a); }) // Sort keys in descending order
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    else if (yAxisSort == sortingOptions.Value) {
        sortedObject = Object.keys(originalObject)
            .sort(function (keyA, keyB) {
            var maxValueA = Math.max.apply(Math, originalObject[keyA].map(function (item) { return item[yAxisKey]; }));
            var maxValueB = Math.max.apply(Math, originalObject[keyB].map(function (item) { return item[yAxisKey]; }));
            return maxValueB - maxValueA;
        })
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    return sortedObject;
}
function generateSeriesStructured(allData, projectColor) {
    // 1. Sort all the data
    allData.sort(function (a, b) { return b.y - a.y; });
    // 2. Add a proper 'x' value to the datapoint
    allData.forEach(function (dataPoint, i) { return dataPoint.x = i; });
    // 3. Assign datapoints to proper series
    var series = [];
    allData.forEach(function (dataPoint, i) {
        if (dataPoint.status === "Unplanned") {
            dataPoint.color = "white";
            // dataPoint.borderColor = "black"; // Uncomment this line if needed
        }
        else {
            dataPoint.color = projectColor[dataPoint.projectName.replace(/\s\s+/g, "_")];
        }
        // series[dataPoint._seriesIndex] = {
        //     ...series[dataPoint._seriesIndex],
        //     name: "<div style='font-weight: normal;'>" + dataPoint.projectName + "</div>",
        //     color: dataPoint.color,
        //     data: [
        //         ...(series[dataPoint._seriesIndex].data && series[dataPoint._seriesIndex].data? series[dataPoint._seriesIndex].data : []),
        //         dataPoint
        //     ]
        // }
        // Finding or creating a series for the current _seriesIndex
        var currentSeries = series.find(function (s) { return s._seriesIndex === dataPoint._seriesIndex; });
        if (currentSeries) {
            currentSeries.data.push(dataPoint);
        }
        else {
            series.push({
                _seriesIndex: dataPoint._seriesIndex,
                data: [dataPoint],
                name: "<div style='font-weight: normal;'>" + dataPoint.projectName + "</div>",
                color: projectColor[dataPoint.projectName.replace(/\s\s+/g, "_")]
            });
        }
    });
    return series;
}
function generateStackedSeries(dataRows, drillDowns, legends, zIndex, stack) {
    if (zIndex === void 0) { zIndex = 6; }
    if (stack === void 0) { stack = 'main'; }
    var categories = dataRows.map(function (row) { return row.name; });
    var newDrillDownSeriesMap = {};
    var series = legends.map(function (legend) {
        var tag = legend.tag, color = legend.color;
        return {
            name: tag,
            color: color,
            zIndex: zIndex,
            data: dataRows.map(function (row, index) {
                var drillDownId = stack + "_" + tag + "_" + index;
                newDrillDownSeriesMap[drillDownId] = {
                    name: row.name + " - " + tag,
                    id: drillDownId,
                    data: undefined,
                    stack: stack
                };
                return { name: row.name, y: 0, drilldown: drillDownId };
            }),
            stack: stack
        };
    });
    drillDowns.forEach(function (dd) {
        var index = categories.indexOf(dd.name);
        dd.data.forEach(function (d, dIndex) {
            series.filter(function (s) { return s.name === d.colorTag; }).forEach(function (s) {
                s.data[index].y += d.y;
                var drillDownId = s.data[index].drilldown;
                var drillDownSeries = newDrillDownSeriesMap[drillDownId];
                if (!drillDownSeries.data) {
                    drillDownSeries.data = dd.data.map(function (node) { return ({ name: node.name, y: 0 }); });
                }
                drillDownSeries.data[dIndex] = d;
                // If no data shows up for a series, the series will be removed.
                s.keep = true;
            });
        });
    });
    return [
        series.filter(function (s) { return s.keep; }),
        Object.values(newDrillDownSeriesMap).filter(function (d) { return d.data; }),
    ];
}
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.05;
        mainSeriesData.forEach(function (row, index) {
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            var rowCopy = __assign(__assign({}, row), { x: totalBars, y: 0 });
            siblingSeriesData.push(rowCopy);
            row.x = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
function getGroupedData(tableJSON) {
    var projects = __spreadArray([], (tableJSON.map(function (obj) { return obj.projectName; })), true).sort();
    var projectColor = {};
    projects.forEach(function (p, index) { return (projectColor[p.replace(/\s\s+/g, "_")] = makeColor(index)); });
    var groupBy = function (array, property) {
        return array.reduce(function (grouped, element) {
            var _a;
            return (__assign(__assign({}, grouped), (_a = {}, _a[element[property]] = __spreadArray(__spreadArray([], (grouped[element[property]] || []), true), [element], false), _a)));
        }, {});
    };
    var groupByName = groupBy(tableJSON, "projectName");
    return { groupByName: groupByName, projectColor: projectColor };
}
exports.getGroupedData = getGroupedData;
function structureForSorting(obj) {
    var combinedArray = [];
    Object.keys(obj).forEach(function (key, seriesIndex) {
        obj[key].forEach(function (item, index) {
            item._seriesIndex = seriesIndex;
            combinedArray.push(item);
        });
    });
    return combinedArray;
}
function getNumberOfBars(mainSeriesData, siblingSeriesData) {
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var barSet_1 = new Set();
        mainSeriesData.forEach(function (row) {
            barSet_1.add(row.name);
        });
        siblingSeriesData.forEach(function (row) {
            barSet_1.add(row.name);
        });
        return barSet_1.size;
    }
    return mainSeriesData.length;
}
function generateChartOptionts(graph, options, chartHeight, series, drilldown, chartType, xDisplay, xAxisOptions) {
    var chartTitle = options.chartTitle, settings = options.settings, timestamp = options.timestamp;
    var summaryView = false;
    return {
        chart: {
            renderTo: 'chartContainerExp',
            type: chartType,
            height: summaryView ? 600 : chartHeight,
            zoomType: 'xy'
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            type: 'category',
            labels: {
                rotation: 0
            }
        },
        yAxis: [{
                min: graph.minValue,
                max: graph.maxValue,
                title: {
                    text: xDisplay
                },
                labels: {
                    formatter: function () {
                        return Intl.NumberFormat("en-US", xAxisOptions ? xAxisOptions : {}).format(Number(this.value));
                    }
                }
            }],
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                return "<b>" + this.key + "</b><br /><i>" + this.point.options.selectedKey + "</i>: " + this.y.toFixed(settings.decimals) + " \n                </br><i>Experiment</i>: " + this.point.options.expName + "\n                </br><i>Status</i>: " + this.point.options.status + "\n                ";
            }
        },
        plotOptions: {
            bar: {
                grouping: false
            },
            series: {
                dataLabels: {
                    enabled: true,
                    color: 'black',
                    rotation: 0,
                    align: 'left',
                    formatter: function () {
                        if (this.point.options.status === 'Unplanned') {
                            // When hasExperiments is "no", show empty bar with no label
                            return '';
                        }
                        else if (this.point.options.expExist === 'Yes' && this.point.options.status != 'Unplanned') {
                            // When hasExperiments is "yes", show the expName with default color
                            var x = this.point.options.expName;
                            // x = truncateText(x, 100)
                            return x;
                        }
                    },
                    inside: true
                }
            }
        },
        series: series,
        responsive: {
            rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            enabled: false
                        }
                    }
                }]
        }
    };
}
function filterZeroImpactIgnorance(dataGot) {
    return dataGot.filter(function (item) { return item.impact > 0 && item.ignorance > 0 && (item.title != "" || item.issue != ""); });
}
exports.filterZeroImpactIgnorance = filterZeroImpactIgnorance;
function formatForBar(dataGot, xAxisKey, xDisplay) {
    return dataGot.map(function (item, index) {
        var borderColor = "gray";
        var nameGot = item.pLabel;
        // if (item.title == "" && item.issue== "") {
        //     nameGot = "Unnamed " + nameGot
        // }
        return {
            "name": nameGot,
            "projectName": item.name,
            "tags": ["all"],
            "colorTag": "2021 Active",
            "groups": null,
            "y": item[xAxisKey],
            "expExist": item.Experiments,
            "status": item.status,
            "expName": item.expName !== "" ? item.expName : "Unnamed",
            "selectedKey": xDisplay,
            "borderWidth": 1,
            "borderColor": borderColor,
            "issueTitle": item.title,
            "issueName": item.issue
        };
    });
}
exports.formatForBar = formatForBar;
function makeColor(colorNum) {
    var hues = [
        0, 20, 30, 40, 50, 60, 80, 120, 160, 190, 210, 230, 260, 290, 330, 360,
    ];
    var lights = [60, 50, 50, 50, 50, 50, 50, 55, 50, 55, 67, 77, 73, 67, 60, 60];
    var goldenFrac = 0.5 * (3 - Math.sqrt(5));
    var x = ((colorNum * goldenFrac) % 1.0) * (hues.length - 1);
    var i = Math.floor(x);
    var f = x % 1.0;
    var hue = (1.0 - f) * hues[i] + f * hues[i + 1];
    var light = (1.0 - f) * lights[i] + f * lights[i + 1];
    var color = "hsl( " + Math.round(hue * 100) / 100 + ", 100%, " + Math.round(light * 100) / 100 + "% )";
    // Check if the generated color is white, and if so, regenerate it
    if (color.toLowerCase() === "hsl( 0, 100%, 100% )") {
        return makeColor(colorNum + 1); // Recursively generate a new color
    }
    return color;
}
exports.makeColor = makeColor;
function getChartOptions(graph, options, xAxisData, yAxisData) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartType = options.chartType;
    var mainSeriesData = graph.mainRows;
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return b.y - a.y; });
    var xAxisKey = xAxisData['data'][xAxisData['selected']]['key'];
    var xDisplay = xAxisData['data'][xAxisData['selected']]['display'];
    var xAxisOptions = JSON.parse(xAxisData['data'][xAxisData['selected']]['options']);
    var mainFilteredData = filterZeroImpactIgnorance(mainSeriesData) || [];
    var mainFormattedData = formatForBar(mainFilteredData, xAxisKey, xDisplay) || [];
    mainFormattedData = mainFormattedData.sort(function (a, b) { return b.y - a.y; });
    var sibFilteredData = filterZeroImpactIgnorance(siblingSeriesData) || [];
    var sibFormattedData = formatForBar(sibFilteredData, xAxisKey, xDisplay) || [];
    sibFormattedData = sibFormattedData.sort(function (a, b) { return b.y - a.y; });
    var totalBars = assignXValue(mainFilteredData, sibFilteredData);
    var chartHeight = getChartHeight(totalBars);
    var mainGroupedData = getGroupedData(mainFormattedData);
    var siblingGroupedData = getGroupedData(sibFormattedData);
    var structuredForSeries = structureForSorting(__assign({}, mainGroupedData.groupByName));
    var series = generateSeriesStructured(structuredForSeries, mainGroupedData.projectColor);
    var drilldown = graph.mainDrillDown.map(function (item) {
        item.stack = 'main';
        return item;
    });
    if (siblingSeriesData.length > 0) {
        var structuredForSeriesSib = structureForSorting(__assign({}, siblingGroupedData.groupByName));
        var siblingSeries = generateSeriesStructured(structuredForSeriesSib, siblingGroupedData.projectColor);
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown.map(function (item) {
            item.stack = 'sib';
            return item;
        }));
    }
    return generateChartOptionts(graph, options, chartHeight, series, drilldown, chartType, xDisplay, xAxisOptions);
}
exports.getChartOptions = getChartOptions;
function getStackBarChartOptions(graph, options, xDisplay) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartType = options.chartType;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return b.y - a.y; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return b.y - a.y; });
    var totalBars = getNumberOfBars(mainSeriesData, siblingSeriesData);
    var chartHeight = getChartHeight(totalBars);
    var _b = generateStackedSeries(mainSeriesData, graph.mainDrillDown, legends, 6, 'main'), series = _b[0], drillDown = _b[1];
    if (siblingSeriesData.length > 0) {
        var _c = generateStackedSeries(siblingSeriesData, graph.siblingDrillDown, siblingLegends, 5, 'sib'), siblingSeries = _c[0], siblingDrillDown = _c[1];
        series = series.concat(siblingSeries);
        drillDown = drillDown.concat(siblingDrillDown);
    }
    return generateChartOptionts(graph, options, chartHeight, series, drillDown, chartType, xDisplay);
}
exports.getStackBarChartOptions = getStackBarChartOptions;
//# sourceMappingURL=compare-experiment.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/compare-experiment/compare-experiment.chart.js